import { createAction } from 'redux-actions';
import { GET_USER_DETAILS, GET_USER_CHATGPT_CREDITS, ADD_MORE_CHATGPT_CREDITS } from '../constants/actionTypes';
import * as getUserDetails from '../api/get-user-details';
import * as resubscribe from '../api/resubscribe-subscription';
import { showErrorSnackbar, showSuccessSnackbar } from './snackbar';
import {
    REQUEST_USER_PACKAGE_INFO_SUCCESS, 
    REQUEST_USER_PACKAGE_INFO_FAILURE
} from '../constants/actionTypes';

const requestFetchUserData = createAction(GET_USER_DETAILS);
const requestUserChatgptCredits = createAction(GET_USER_CHATGPT_CREDITS);
const requestAddMoreChatgptCredits = createAction(ADD_MORE_CHATGPT_CREDITS);

const requestUserPackageInfoSuccess = createAction(REQUEST_USER_PACKAGE_INFO_SUCCESS);
const requestUserPackageInfoFailure = createAction(REQUEST_USER_PACKAGE_INFO_FAILURE);

// eslint-disable-next-line import/prefer-default-export
export function getUserDetailsData(params) {
    return dispatch => getUserDetails.getUserDetailsData(params)
        .then((data) => {
            console.log("user data>>",data);
            dispatch(requestFetchUserData(data))
        })
        .catch(error => {
            console.log("error>>>",error);
            if(error?.response?.status === 401){
                dispatch(showErrorSnackbar('Session is Expired!!!'));
              }
            else if(error?.response?.status === 400 && error?.response?.data?.errors?.error?.includes("credits") ){
        dispatch(showErrorSnackbar('Please add more credits'));
    }
            else{
                dispatch(showErrorSnackbar(error?.response?.data?.errors?.error));
        }
        return false;
        });
}

// eslint-disable-next-line import/prefer-default-export
export function getUserSubscriptionInfo() {
    return dispatch => getUserDetails.getUserSubscriptionInfo()
    .then(({ data }) => dispatch(requestUserPackageInfoSuccess(data)))
        .catch(error => {
            if(error?.response?.status === 401){
                dispatch(showErrorSnackbar('Session is Expired!!!'));
              }else{
                dispatch(showErrorSnackbar(error?.response?.data?.errors?.error));
        }});
}

// eslint-disable-next-line import/prefer-default-export
export function updateUserSubscriptionInfo(data) {
    // return dispatch => getUserDetails.updateUserSubscriptionInfo(data)
    //     .catch(error => {
    //         if(error?.response?.status === 401){
    //             dispatch(showErrorSnackbar('Session is Expired!!!'));
    //           }else{
    //         dispatch(showErrorSnackbar('Something went wrong, please try again getUserDetailsData' ));
    //     }});
    return dispatch => getUserDetails.updateSubscription(data)
        .catch(error => {
            if(error?.response?.status === 401){
                dispatch(showErrorSnackbar('Session is Expired!!!'));
              }else{
            dispatch(showErrorSnackbar(error?.response?.data?.errors?.error));
        }});
}

export function getdeleteIpAddress(params) {
    return dispatch => getUserDetails.getDeleteUserIp(params)
        .then((data) => {
            dispatch(requestFetchUserData(data))
            dispatch(showSuccessSnackbar('Sucessfully deleted IP Address.'));
        })
        .catch(error => {
            if(error?.response?.status === 401){
                dispatch(showErrorSnackbar('Session is Expired!!!'));
              }else{
            dispatch(showErrorSnackbar('Something went wrong, please try again getdeleteIpAddress'));
         } });
}

export function updateUserDetailsInSettings(params) {
    return dispatch => getUserDetails.updateUserDetailsInSettings(params)
        .then((data) => {
            dispatch(getUserDetailsData({user_id:params.user_id}));
            dispatch(showSuccessSnackbar('Personal details successfully updated.'));
        })
        .catch(error => {
            if(error?.response?.status === 401){
                dispatch(showErrorSnackbar('Session is Expired!!!'));
              }else{
            dispatch(showErrorSnackbar('Something went wrong, please try again.'));
         } });
}


export function updatePaymentDetails(params) {
    return dispatch => getUserDetails.updateUserDetailsInSettings(params)
        .then((data) => {
            dispatch(getUserDetailsData({user_id:params.user_id}));
            dispatch(showSuccessSnackbar('Personal details successfully updated.'));
        })
        .catch(error => {
            if(error?.response?.status === 401){
                dispatch(showErrorSnackbar('Session is Expired!!!'));
              }else{
            dispatch(showErrorSnackbar('Something went wrong, please try again.'));
         } });
}

export function sendOtpforPasswordChange(userId) {
    return dispatch => getUserDetails.sendOtpforPasswordChange({userId})
        .then((data) => {

        })
        .catch(error => {
            if(error?.response?.status === 401){
                dispatch(showErrorSnackbar('Session is Expired!!!'));
              }else{
            dispatch(showErrorSnackbar('Something went wrong, please try again sendOtpforPasswordChange'));
        }});
}


export function updateUserPassword(params) {

    return dispatch => getUserDetails.userPasswordChange(params)
        .then((data) => {
            dispatch(getUserDetailsData({user_id:params.user_id}));
            dispatch(showSuccessSnackbar('Sucessfully updated user password'));
        })
        .catch(error => {
            if(error?.response?.status === 401){
                dispatch(showErrorSnackbar('Session is Expired!!!'));
              }else{
            dispatch(showErrorSnackbar('Something went wrong, please try again update user password'));
         } });
}


export function getUserChatgptCredits() {
    return dispatch => getUserDetails.getChatgptCredits()
        .then((data) => {
            console.log("user data>>",data);
            dispatch(requestUserChatgptCredits(data))
        })
        .catch(error => {
            if(error?.response?.status === 401){
                dispatch(showErrorSnackbar('Session is Expired!!!'));
              }else{
                dispatch(showErrorSnackbar(error?.response?.data?.errors?.error));
        }});
}

export function addChatgptCredits(params) {

    return dispatch => getUserDetails.addMoreChatgptCredits(params)
        .then((data) => {
            dispatch(requestAddMoreChatgptCredits(data));
            dispatch(showSuccessSnackbar('Sucessfully added credits'));
            return data;
        })
        .catch(error => {
            if(error?.response?.status === 401){
                dispatch(showErrorSnackbar('Session is Expired!!!'));
              }else{
            dispatch(showErrorSnackbar(error?.response?.data?.errors?.error));
         } });
}

export function resubscribeUserSubscription(params) {
    return dispatch => resubscribe.resubscribeSubscription(params)
        .then((data) => {
            dispatch(showSuccessSnackbar('Sucessfully Resubscribed!'));
            return data;
        })
        .catch(error => {
            if(error?.response?.status === 401){
                dispatch(showErrorSnackbar('Session is Expired!!!'));
              }else{
            dispatch(showErrorSnackbar(error?.response?.data?.errors?.error));
        }});
}

